import { render } from "./MilestoneAction.vue?vue&type=template&id=064c25f2"
import script from "./MilestoneAction.vue?vue&type=script&lang=js"
export * from "./MilestoneAction.vue?vue&type=script&lang=js"

import "./MilestoneAction.vue?vue&type=style&index=0&id=064c25f2&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__